import React from "react";
import { graphql } from "gatsby";
import Layout from "../../components/Layout";
import WithI18next from "../../components/WithI18next";
import ZipWorldLayout from "../../layouts/ZipWorldLayout";

const ZipWorldPage = ({ data, t }) => {
  return (
    <Layout
      title={t("zipworld.seo.title")}
      description={t("zipworld.seo.description")}
    >
      <ZipWorldLayout data={data} t={t} />
    </Layout>
  );
};

export default WithI18next()(ZipWorldPage);

export const query = graphql`
  query ($wpLocale: String!, $wpGlobalConfig: String!) {
    heroContent: allWpHeroSectionItem(
      filter: {
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { eq: $wpGlobalConfig } }
        acfHeroSections: { hsPage: { eq: "zipworld" } }
      }
    ) {
      edges {
        node {
          acfHeroSections {
            hsMainHeading
            hsMainText
            hsButtonText
            hsButtonLink
          }
        }
      }
    }

    imagineItContent: allWpPartialItem(
      filter: {
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { eq: $wpGlobalConfig } }
        acfPartials: { pPartialId: { eq: "zipworld-imagine-it" } }
      }
      sort: { order: ASC, fields: date }
    ) {
      nodes {
        acfPartials {
          pHeading
          pContent
          pIcon {
            localFile {
              publicURL
            }
          }
        }
      }
    }

    experienceContent: allWpPartialItem(
      filter: {
        acfGlobalConfiguration: { gcLinkTo: { eq: $wpGlobalConfig } }
        acfPartials: { pPartialId: { eq: "zipworld-experience" } }
      }
      sort: { order: ASC, fields: date }
    ) {
      nodes {
        acfPartials {
          pHeading
          pIcon {
            localFile {
              publicURL
            }
          }
        }
      }
    }

    redeemContent: allWpPartialItem(
      filter: {
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { eq: $wpGlobalConfig } }
        acfPartials: { pPartialId: { eq: "zipworld-redeem" } }
      }
      sort: { order: ASC, fields: date }
    ) {
      nodes {
        acfPartials {
          pContent
          pHeading
          pIcon {
            localFile {
              publicURL
            }
          }
        }
      }
    }

    enterZipWorldContent: allWpPartialItem(
      filter: {
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { eq: $wpGlobalConfig } }
        acfPartials: { pPartialId: { eq: "zipworld-enter" } }
      }
    ) {
      edges {
        node {
          acfPartials {
            pContent
            pHeading
            pButtonText
            pButtonUrl
          }
        }
      }
    }

    beTheFirstContent: allWpPartialItem(
      filter: {
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { eq: $wpGlobalConfig } }
        acfPartials: { pPartialId: { eq: "zipworld-be-the-first" } }
      }
    ) {
      edges {
        node {
          acfPartials {
            pContent
            pHeading
          }
        }
      }
    }

    faqsContent: allWpSupportCenterItem(
      filter: {
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { eq: $wpGlobalConfig } }
        categories: { nodes: { elemMatch: { slug: { eq: "zipworld" } } } }
      }
      sort: { order: DESC, fields: date }
      limit: 5
    ) {
      edges {
        node {
          title
          content
        }
      }
    }
  }
`;
